import styled from 'styled-components';
import { dfdDefaultTheme } from 'theme/material-ui';
import FlexBox from 'components/UI/Layout/FlexBox';

export const RowItem = styled(FlexBox)`
  ${dfdDefaultTheme.breakpoints.up('lg')} {
    display: grid;
    grid-auto-flow: column;
    gap: 20px;
    flex-direction: row;
    align-items: center;
  }
`;
